import { useSheetContext } from "@/context/sheet";
import { useCreateTour } from "@/hooks/tours";
import { CreateTour } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(tours)/tours/_sheet/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutateAsync } = useCreateTour({
    onSuccess: (tour) => {
      close(() => {
        navigate({
          to: "/tours",
          params: { id: tour.id.toString() },
        });
      });
    },
  });

  const create = async (tour: CreateTour) => {
    await mutateAsync(tour);
  };

  return <Form onUpsert={create} />;
}
